export var LooksLike;
(function (LooksLike) {
    LooksLike["LOOKS_LIKE_EPOCH_MS"] = "epoch_ms";
    LooksLike["LOOKS_LIKE_EPOCH_S"] = "epoch_s";
    LooksLike["LOOKS_LIKE_ISO8601"] = "iso8601";
    LooksLike["LOOKS_LIKE_DATE_ISO"] = "date_iso";
    LooksLike["LOOKS_LIKE_UUID"] = "uuid";
    LooksLike["LOOKS_LIKE_EMAIL"] = "email";
})(LooksLike || (LooksLike = {}));
